<template>
  <a :href="generateUrl(props.params)" target="_blank" class="orders-grid-sales-number" :title="props.params.value">
    {{ props.params.value }}
  </a>
</template>

<script setup lang="ts">
import { OrderEditType } from '@/constants/orderEditType';
import { AddEditOrderBreadcrumbSteps } from '@/models/add-edit-order-breadcrumb-steps.enum';
import { OrderStatus, OrderType } from '@onrunning/backstage-models';

export interface Props {
  // TODO : eventually should add type for params
  params: any; // Provided by ag-grid
}

const props = defineProps<Props>();

const generateUrl = (params: any): string => {
  const data = params.data;
  let path = '';

  const withRelatedOrders = data.type === OrderType.MultiplePreOrder;
  const queryString = withRelatedOrders ? '?showRelatedOrders=true' : '';
  const isDraft = data.status === OrderStatus.NotSubmitted;

  if (isDraft) {
    path = `/orders/${data.id}/edit-products/${OrderEditType.Draft}/${AddEditOrderBreadcrumbSteps.productsQuantities}${queryString}`;
  } else {
    path = `/orders/${data.id}${queryString}`;
  }

  return `${window.location.origin}${path}`;
};
</script>

<style lang="scss" scoped>
.orders-grid-sales-number {
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: underline;
  cursor: pointer;
}
</style>
